export * from './usePermissionDetail';
